<div class="g-0">
    <div class="col">
        <div class="box-wrapper">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-user-group"></i>
                                <span class="ms-2">Operatori Proiect</span>
                            </div>
                            <button
                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                class="btn btn-small btn-primary edit-btn" (click)="toggleEditField()">
                                <i class="fa fa-pencil" *ngIf="!showEditField"></i>
                                <i class="fa fa-close" *ngIf="showEditField"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Operator</th>
                            <th scope="col">Telefon</th>
                            <th scope="col">Responsabil Teren?</th>
                            <th scope="col" *ngIf="showEditField">Acțiuni</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let operator of operatoriProiect; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>{{ operator.name }}</td>
                            <td>{{ operator.telefon || 'n/a' }}</td>
                            <td>{{ operator.primary_agent === 1 ? 'DA' : 'NU' }}</td>
                            <td *ngIf="showEditField">
                                <div class="d-flex align-center">
                                    <button *ngIf="operator.primary_agent !== 1" type="button"
                                        class="btn btn-sm btn-success action-button me-1" title="Responsabil"
                                        (click)="setPrimaryOperator(operator.id)">
                                        Responsabil
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger action-button" title="Șterge"
                                        (click)="removeOperator(operator.id)">
                                        <img class="btn-img" src="/assets/icons/delete.svg" alt="delete" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ng-container *ngIf="showEditField">
                    <form class="p-1" [formGroup]="form" (submit)="submitForm()">
                        <div class="row">
                            <div class="col-md-10">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Operator Teren</mat-label>
                                    <mat-select formControlName="id_operator">
                                        <mat-option *ngFor="let row of operatoriTeren" [value]="row.id">
                                            {{ row.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['id_operator'].valid && form.controls['id_operator'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2 d-flex align-items-center">
                                <button class="btn btn-small btn-primary" type="submit" [disabled]="form.invalid">
                                    Adaugă
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>